import * as Stammdaten from '@Modules/Stammdaten';
import type { RouteObject } from 'react-router';
import { setupModuleRouting } from './setupModuleRouting';

export function setupStammdatenRoutes(): RouteObject {
    return {
        path: 'stammdaten',
        children: [
            setupModuleRouting({
                resourcePath: 'addresses',
                editFrame: <Stammdaten.FrameEditAddress />,
                listFrame: <Stammdaten.FrameListAddress />,
            }),
            setupModuleRouting({
                resourcePath: 'contacts',
                editFrame: <Stammdaten.FrameEditContact />,
                listFrame: <Stammdaten.FrameListContact />,
            }),
            setupModuleRouting({
                resourcePath: 'cost_centers',
                editFrame: <Stammdaten.FrameEditCostCenter />,
                listFrame: <Stammdaten.FrameListCostCenter />,
            }),
            setupModuleRouting({
                resourcePath: 'cost_bearers',
                editFrame: <Stammdaten.FrameEditCostBearer />,
                listFrame: <Stammdaten.FrameListCostBearer />,
            }),
            setupModuleRouting({
                resourcePath: 'payment_terms',
                editFrame: <Stammdaten.FrameEditPaymentTerms />,
                listFrame: <Stammdaten.FrameListPaymentTerms />,
            }),
            setupModuleRouting({
                resourcePath: 'vehicles',
                editFrame: <Stammdaten.FrameEditVehicle />,
                listFrame: <Stammdaten.FrameListVehicle />,
            }),
            setupModuleRouting({
                resourcePath: 'vehicle_types',
                editFrame: <Stammdaten.FrameEditVehicleType />,
                listFrame: <Stammdaten.FrameListVehicleType />,
            }),
            setupModuleRouting({
                resourcePath: 'storage_locations',
                editFrame: <Stammdaten.FrameEditStorageLocation />,
                listFrame: <Stammdaten.FrameListStorageLocation />,
            }),
            setupModuleRouting({
                resourcePath: 'construction_sites',
                editFrame: <Stammdaten.FrameEditConstructionSite />,
                listFrame: <Stammdaten.FrameListConstructionSite />,
            }),
            setupModuleRouting({
                resourcePath: 'avv',
                editFrame: <Stammdaten.FrameEditAvv />,
                listFrame: <Stammdaten.FrameListAvv />,
            }),
            setupModuleRouting({
                resourcePath: 'containers',
                editFrame: <Stammdaten.FrameEditContainer />,
                listFrame: <Stammdaten.FrameListContainer />,
            }),
            setupModuleRouting({
                resourcePath: 'container_types',
                editFrame: <Stammdaten.FrameEditContainerType />,
                listFrame: <Stammdaten.FrameListContainerType />,
            }),
            setupModuleRouting({
                resourcePath: 'rent_variants',
                editFrame: <Stammdaten.FrameEditRentVariant />,
                listFrame: <Stammdaten.FrameListRentVariant />,
            }),
            setupModuleRouting({
                resourcePath: 'services',
                editFrame: <Stammdaten.FrameEditService />,
                listFrame: <Stammdaten.FrameListService />,
            }),
            setupModuleRouting({
                resourcePath: 'ledger_accounts',
                editFrame: <Stammdaten.FrameEditLedgerAccount />,
                listFrame: <Stammdaten.FrameListLedgerAccount />,
            }),
            setupModuleRouting({
                resourcePath: 'vat',
                editFrame: <Stammdaten.FrameEditVat />,
                listFrame: <Stammdaten.FrameListVat />,
            }),
        ],
    };
}
